export default {
  namespaced: true,
  state: {
    search: {
      error: true,
      filters: {},
      clear: false
    },
  },
  getters: {
    getSearch: (state) => state.search,
  },
  mutations: {
    FILTERS_ERROR (state, status) {
      state.search.error = status
    },
    TOGGLE_FILTERS (state, status) {
      state.search.filters = status
    },
    CLEAR_FILTERS (state) {
      state.search.filters = {}
    },
    CLEAR_SEARCH (state, status) {
      state.search.clear = status
    }
  },
  actions: {
    toggleFilters ({ commit }, status) {
      commit('TOGGLE_FILTERS', status)
    },
    clearFilters ({ commit }) {
      commit('CLEAR_FILTERS')
    },
    clearSearch ({ commit }, status) {
      commit('CLEAR_SEARCH', status)
    },
    filtersError ({ commit }, status) {
      commit('FILTERS_ERROR', status)
    }
  }
}
